import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useGetUserPermissionQuery } from "../store/services/user";
import { checkPermission } from "../utils/commonMethods";

const Protected = () => {
  const navigate = useNavigate();
  const { pathname,search } = useLocation();
  const { auth } = useSelector((state) => state.auth);
  const { data: permission, isLoading: permissionLoading } = useGetUserPermissionQuery(auth?._id, {
    skip: !auth?._id || pathname !== "/lead-pool",
  });

  useEffect(() => {
    if (!auth) {
      sessionStorage.setItem("requestUrl", pathname + search);
      navigate("/auth/login");
      return;
    }
  }, [auth]);

  if (!auth) return null;
  if (
    auth.role === "agent" &&
    (pathname.startsWith("/HrManagement/dashboard") ||
      pathname === "/HrManagement/attendance")
  ) {
    return (
      <Navigate to={`/HrManagement/individualAtt/${auth._id}`} replace />
    );
  }
  if (pathname === "/lead-pool" && permissionLoading) return null;
  if (pathname === "/lead-pool" && !checkPermission(permission?.permissions || {}, "Leads", "leadPoolManagement", auth.role)) return <Navigate to="/leads" replace />;

  return <Outlet />;
};

export default Protected;
